import React from 'react';
import ReactDOM from 'react-dom';
import '../../assets/css/modal.css';
import '../../assets/css/popup.css';

class ModalDialog extends React.Component {
    constructor(props) {
        super(props);
        this.rootElement = document.getElementById('root');
        this.dialogWrapper = document.createElement('div');
    }

    componentDidMount() {
        this.rootElement.appendChild(this.dialogWrapper);
        const overlay = document.createElement('div');
        overlay.classList.add('modal');
        overlay.classList.add('page-overlay');
        this.dialogWrapper.appendChild(overlay);
        overlay.addEventListener('click', (e)=> {
            this.props.CloseCallBack();
        })
    }

    render() {
        return ReactDOM.createPortal(
            <DialogContent DialogHeader={this.props.DialogHeader} DialogRef={this.props.DialogRef} DialogStyle={this.props.DialogStyle} CloseCallBack={this.props.CloseCallBack}/>,
            this.dialogWrapper
          );
    }
}

export default ModalDialog


const DialogContent = ({DialogHeader, DialogRef, DialogStyle, CloseCallBack}) => {
        return (
            <div aria-hidden="false" ref={DialogRef} className="w_modal m_articleModal contactus  m_tooltipmodal-width vzrf" data-modal="payBill" role="dialog" style={DialogStyle} tabIndex="0">
                <div className="modal-header" data-modal-header="">
                    <div className="modal_header article-modal_header" data-modal-header="">
                        <p className="heading h4">{DialogHeader}</p>
                        <div role="button" aria-label="Click here or press escape key to close the modal" className="modal_x m_right m_articleModal-close" data-close-modal="" tabIndex="0" onClick={CloseCallBack} onKeyDown={CloseCallBack} >
                            &nbsp;</div>
                    </div>
                </div>
                <div className="modal_content padding-top-zero padding-bottom-large">
                    <div className="padding-vert-small">
                    </div>
                </div>
                <div className="modal_footer" data-modal-footer="">
                    <a className="button p-50" tabIndex="0" role="button" onClick={CloseCallBack} onKeyDown={CloseCallBack}>Done</a>
                </div>

            </div>
        )
}





// WEBPACK FOOTER //
// ./src/components/modules/Popup.js